import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import { NormalizedDistributionProduct } from '../../../../../../store/managementAnalysis/types';
import { CheckingAccountQueryData } from '../../../../../../store/managementAnalysisDetails/selector';
import { LateralProductBar } from '../../LateralProductBar';

import { tableHead } from './constants';

interface ProductSearchItemProps {
  item: Utils.ArrayElement<NonNullable<CheckingAccountQueryData>>;
  product: NormalizedDistributionProduct;
}

const ProductSearchItem = ({ item, product }: ProductSearchItemProps) => {
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} py="stack.xxs" px="inline.xxxs">
      <LateralProductBar backgroundColor={product.color} />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{item.customerNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.advisorNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.availableValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.totalValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
